<template>
  <div class="home">
    <div class="w-full flex justify-center">
      <img class="w-44" alt="Vue logo" src="../assets/logo.png">
    </div>
    <p>Debe ingresar a la web dede <a href="www.charko.com.ar">www.charko.com.ar</a></p>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  mounted() {
    window.location.href = 'https://www.charko.com.ar';
  }
}
</script>
